/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListAllPartsForOfflineQueryResponse, ListAllPartsForOfflinePathParams, ListAllPartsForOfflineQueryParams, ListAllPartsForOffline400, ListAllPartsForOffline401, ListAllPartsForOffline403, ListAllPartsForOffline404, ListAllPartsForOffline409, ListAllPartsForOffline500 } from "../../types/equipmentController/ListAllPartsForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListAllPartsForOfflineUrl(organizationId: ListAllPartsForOfflinePathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/equipment/parts/all` as const }
  return res
}

/**
 * @summary Full non-paginated parts dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/equipment/parts/all}
 */
export async function listAllPartsForOffline(organizationId: ListAllPartsForOfflinePathParams["organizationId"], params?: ListAllPartsForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListAllPartsForOfflineQueryResponse, ResponseErrorConfig<ListAllPartsForOffline400 | ListAllPartsForOffline401 | ListAllPartsForOffline403 | ListAllPartsForOffline404 | ListAllPartsForOffline409 | ListAllPartsForOffline500>, unknown>({ method : "GET", url : getListAllPartsForOfflineUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}